import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Notification } from 'src/app/models/NotificationModel';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import * as InlineEditor from '@ckeditor/ckeditor5-build-inline';

@Component({
  selector: 'cw-ci-notification-edit',
  templateUrl: './notification-edit.component.html',
  styleUrls: ['./notification-edit.component.scss']
})
export class NotificationEditComponent implements OnInit {
  public ckConfig = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'insertTable', 'undo', 'redo'
    ]
  };

  public Editor = InlineEditor;

  _notification: Notification;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set notification(value: Notification) {
    this._notification = value;
    this.notificationForm.reset();
    if (this._notification.id) {
      this.notificationForm.controls.subject.setValue(this._notification.subject);
      this.notificationForm.controls.type.setValue(this._notification.type);
      this.notificationForm.controls.message.setValue(this._notification.message);
    }
  }

  notificationForm = new FormGroup ({
    subject: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
  });

  constructor(private _platformApi: PlatformApiService) { }

  ngOnInit() {
    console.log(this.Editor.defaultConfig);
  }

  saveNotification() {
    if (this.notificationForm.valid) {
      const saveNotification = new Notification({
        subject: this.notificationForm.value.subject,
        type: this.notificationForm.value.type,
        message: this.notificationForm.value.message
      });
      if (this._notification.id) {
        saveNotification.id = this._notification.id;
      }

      this._platformApi.saveNotification(saveNotification).subscribe(
        resp => {
          this.stateChange.emit({state: 'CREATESUCCESS'})
        }
      );
    }
  }

  cancel() {
    this.notificationForm.reset();
    this.stateChange.emit({state: 'EDITCANCEL'});
  }
}
